"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UnmanagedDetails_1 = require("../UnmanagedDetails");
var ManagedOpenableComponent_1 = require("../../utils/hoc/ManagedOpenableComponent");
/**
 * The Details component consists of a heading and a content block. By
 * default, the content block is not displayed until the user clicks on the
 * heading.
 *
 * This component therefore corresponds to
 * the [`<details>`](https://html.spec.whatwg.org/multipage/forms.html#the-details-element)
 * element from HTML5, which has not yet been implemented in all supported
 * browsers.
 */
exports.Details = ManagedOpenableComponent_1.withManagedIsOpenState(UnmanagedDetails_1.UnmanagedDetails);
exports.Details.displayName = 'Details';
exports.default = exports.Details;
//# sourceMappingURL=Details.js.map
